var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "microphoneDialog",
      attrs: {
        title: "🎙️ 麦克风权限开启指引",
        visible: _vm.visible,
        width: "900px",
        "close-on-click-modal": false,
        "custom-class": "microphone-permission-guide-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c("div", { staticClass: "guide-container" }, [
        _c("p", { staticClass: "guide-subtitle" }, [
          _vm._v(
            "面试录音需要浏览器麦克风权限，请根据您的使用环境参考以下操作"
          ),
        ]),
        _c(
          "div",
          { staticClass: "tab-bar" },
          _vm._l(_vm.tabs, function (tab) {
            return _c(
              "button",
              {
                key: tab.key,
                staticClass: "tab-btn",
                class: { active: _vm.activeTab === tab.key },
                on: {
                  click: function ($event) {
                    _vm.activeTab = tab.key
                  },
                },
              },
              [_vm._v(" " + _vm._s(tab.label) + " ")]
            )
          }),
          0
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeTab === "win-wecom",
                expression: "activeTab === 'win-wecom'",
              },
            ],
            staticClass: "tab-panel",
          },
          [
            _c("div", { staticClass: "section" }, [
              _c("h2", [_vm._v("Windows 企微浏览器")]),
              _c("p", { staticClass: "desc" }, [
                _c("strong", [_vm._v("第一步：")]),
                _vm._v(
                  "点击「开始录音」后，会弹出「申请使用 🎤 麦克风」对话框，点击 "
                ),
                _c("strong", [_vm._v("「允许」")]),
                _vm._v("。 "),
              ]),
              _c("div", { staticClass: "img-box" }, [
                _c("img", {
                  attrs: {
                    src: _vm.winWecomAllowImg,
                    alt: "Windows企微申请使用麦克风",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.showLightbox(_vm.winWecomAllowImg)
                    },
                  },
                }),
              ]),
              _c(
                "p",
                { staticClass: "desc", staticStyle: { "margin-top": "18px" } },
                [
                  _c("strong", [_vm._v("补充：")]),
                  _vm._v(
                    "如果第一步误点了「取消」或未授权，可以点击地址栏左侧的 "
                  ),
                  _c("strong", [_vm._v("🔒 图标")]),
                  _vm._v("，在弹出的面板中勾选 "),
                  _c("strong", [_vm._v("麦克风：☑ 允许")]),
                  _vm._v("，然后点击 "),
                  _c("strong", [_vm._v("「确定」")]),
                  _vm._v("，页面会重新加载并获得权限。 "),
                ]
              ),
              _c("div", { staticClass: "img-box" }, [
                _c("img", {
                  attrs: {
                    src: _vm.winWecomImg,
                    alt: "Windows企微浏览器麦克风权限",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.showLightbox(_vm.winWecomImg)
                    },
                  },
                }),
              ]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeTab === "mac-wecom",
                expression: "activeTab === 'mac-wecom'",
              },
            ],
            staticClass: "tab-panel",
          },
          [
            _c("div", { staticClass: "section" }, [
              _c("h2", [_vm._v("Mac 企微浏览器（Safari 内核）")]),
              _c("p", { staticClass: "desc" }, [
                _vm._v(" 点击「开始录音」后，系统会弹出 "),
                _c("strong", [
                  _vm._v('「允许 "ihire.dhrforce.com" 使用你的麦克风？」'),
                ]),
                _vm._v(" 对话框，点击 "),
                _c("strong", [_vm._v("「允许」")]),
                _vm._v("。 "),
                _c("br"),
                _vm._v("如果之前拒绝过，可右键地址栏选择 "),
                _c("strong", [_vm._v("「网站设置…」")]),
                _vm._v("，将麦克风改为 "),
                _c("strong", [_vm._v("「询问」")]),
                _vm._v(" 或 "),
                _c("strong", [_vm._v("「允许」")]),
                _vm._v("，然后刷新页面。 "),
              ]),
              _c("div", { staticClass: "img-box" }, [
                _c("img", {
                  attrs: {
                    src: _vm.macWecomImg,
                    alt: "Mac企微浏览器麦克风权限",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.showLightbox(_vm.macWecomImg)
                    },
                  },
                }),
              ]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeTab === "chrome",
                expression: "activeTab === 'chrome'",
              },
            ],
            staticClass: "tab-panel",
          },
          [
            _c("div", { staticClass: "section" }, [
              _c("h2", [_vm._v("Chrome 浏览器")]),
              _c("p", { staticClass: "desc" }, [
                _vm._v(" 首次录音时浏览器会弹出权限请求，选择 "),
                _c("strong", [_vm._v("「访问网站时允许」")]),
                _vm._v(" 或 "),
                _c("strong", [_vm._v("「仅这次访问时允许」")]),
                _vm._v("。 "),
                _c("br"),
                _vm._v("如果之前拒绝过，点击地址栏左侧 "),
                _c("strong", [_vm._v("🔒 锁头图标")]),
                _vm._v("，找到「麦克风」将其改为 "),
                _c("strong", [_vm._v("允许")]),
                _vm._v("，或点击 "),
                _c("strong", [_vm._v("「重置权限」")]),
                _vm._v(" 后刷新页面。 "),
              ]),
              _c("div", { staticClass: "img-box" }, [
                _c("img", {
                  attrs: { src: _vm.chromeImg, alt: "Chrome浏览器麦克风权限" },
                  on: {
                    click: function ($event) {
                      return _vm.showLightbox(_vm.chromeImg)
                    },
                  },
                }),
              ]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeTab === "safari",
                expression: "activeTab === 'safari'",
              },
            ],
            staticClass: "tab-panel",
          },
          [
            _c("div", { staticClass: "section" }, [
              _c("h2", [_vm._v("Safari 浏览器")]),
              _c("p", { staticClass: "desc" }, [
                _vm._v(" 打开 "),
                _c("strong", [
                  _vm._v("Safari → 偏好设置（⌘+,）→ 网站 → 麦克风"),
                ]),
                _vm._v("，在右侧找到对应网站，将权限从「拒绝」改为 "),
                _c("strong", [_vm._v("「询问」")]),
                _vm._v(" 或 "),
                _c("strong", [_vm._v("「允许」")]),
                _vm._v("，然后刷新页面。 "),
              ]),
              _c("div", { staticClass: "img-box" }, [
                _c("img", {
                  attrs: { src: _vm.safariImg, alt: "Safari浏览器麦克风权限" },
                  on: {
                    click: function ($event) {
                      return _vm.showLightbox(_vm.safariImg)
                    },
                  },
                }),
              ]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeTab === "meeting",
                expression: "activeTab === 'meeting'",
              },
            ],
            staticClass: "tab-panel",
          },
          [
            _c("div", { staticClass: "section" }, [
              _c("h2", [_vm._v("开启腾讯会议时低音量")]),
              _c("p", { staticClass: "desc" }, [
                _c("strong", [_vm._v("提示：")]),
                _vm._v(
                  "点击开始录音后，后台的腾讯会议声音会受影响，很小，要很大声对方才能听到 "
                ),
              ]),
              _c("p", { staticClass: "desc" }, [
                _c("strong", [_vm._v("处理方式：")]),
              ]),
              _c("div", { staticClass: "img-box" }, [
                _c("img", {
                  attrs: {
                    src: _vm.tencentMeetingImg,
                    alt: "腾讯会议音频设置",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.showLightbox(_vm.tencentMeetingImg)
                    },
                  },
                }),
              ]),
            ]),
          ]
        ),
      ]),
      _vm.lightboxVisible
        ? _c(
            "div",
            {
              staticClass: "lightbox",
              on: {
                click: function ($event) {
                  _vm.lightboxVisible = false
                },
              },
            },
            [_c("img", { attrs: { src: _vm.lightboxImg, alt: "" } })]
          )
        : _vm._e(),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleClose } },
            [_vm._v("我知道了")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }